import { useForm } from "react-hook-form";
var DEFAULT_VALUES = {
    code: "",
    label: "",
    transaction: "",
    description: "",
    action: "",
    actionDescription: "",
};
export var useDraftCodeForm = function (props) {
    var _a = useForm({
        mode: "onTouched",
        defaultValues: DEFAULT_VALUES,
    }), control = _a.control, handleSubmit = _a.handleSubmit, reset = _a.reset;
    var onSubmit = handleSubmit(function (values) {
        props.onAddDraftCode(values);
        reset(DEFAULT_VALUES);
    });
    return { control: control, onSubmit: onSubmit };
};
